import customFetch from "../hooks/fetchWrapper";
import toast from "react-hot-toast";

export const login = async (credentials) => {
  return toast.promise(
    customFetch("login", {
      method: "POST",
      body: JSON.stringify(credentials),
    }),
    {
      loading: "Logging in...",
      success: (data) => {
        if (!data.status) {
          // If status is false, throw error with response message
          throw new Error(data.message);
        }
        // Save token and user details if login is successful
        localStorage.setItem("token", data.data.token);
        localStorage.setItem("userId", data.data.uid ? data.data.uid.toString() : "");
        localStorage.setItem("userEmail", data.data.email || "");
        localStorage.setItem("hasStudents", data.data.hasStudents ? "true" : "false");
        localStorage.setItem("students", JSON.stringify(data.data.students || []));
        localStorage.setItem("studentdata", JSON.stringify(data.data.student));
        localStorage.setItem("busRouteData", JSON.stringify(data?.data?.busRouteData));
        return data.message; // Will show "Login successful"
      },
      error: (err) => err.message || "Login failed. Please try again later.", // Show exact error message or fallback
    }
  );
};

export const register = async (credentials) => {
  return toast.promise(
    customFetch("users", {
      method: "POST",
      body: JSON.stringify(credentials),
    }),
    {
      loading: "Registering...",
      success: (data) => {
        if (!data.status) {
          // If status is false, throw error with response message
          throw new Error(data.message);
        }
        return data.message; // Will show "Registration successful" or any other success message from the API
      },
      error: (err) => err.message || "Registration failed. Please try again later.", // Show exact error message or fallback
    }
  );
};
